$( document ).ready(function() {
    $(".piano-lesson-page #shopify-section-custom-contact-form h4 strong").html("Fill Our Form To Get Started");
});

$(document).ready(function() {
    $('#customButton').on('click', function() {
      // Your code to show a Bootstrap modal or any other popup
      alert('Button clicked!');
    });
  });